import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { ScrollReveal } from './useScrollReveal';
export function TomosSection() {
  const tomos = [{
    emoji: '🗣️',
    title: 'Tomo 1 — Comunicación Anti-Explosiva',
    subtitle: 'Protocolos SOS para detener discusiones',
    desc: 'Peleas que escalan, silencios que lastiman, palabras que quedan. El sistema completo para hablar sin gritar, escucharse sin pelear y resolver conflictos antes de que causen daño irreparable.',
    color: 'from-emerald-500/20 to-emerald-900/20',
    border: 'border-emerald-500/30'
  }, {
    emoji: '💑',
    title: 'Tomo 2 — Re-Conexión Íntima',
    subtitle: 'Más allá del sexo: complicidad y vínculo',
    desc: 'Los 5 niveles de intimidad, los lenguajes del amor en versión latinoamericana, el sistema de 5 puntos de contacto diarios y el mapa del reencuentro físico sin presión.',
    color: 'from-red-500/20 to-red-900/20',
    border: 'border-red-500/30'
  }, {
    emoji: '💰',
    title: 'Tomo 3 — Finanzas en Paz',
    subtitle: 'Acuerdos de abundancia para crecer juntos',
    desc: 'El sistema de los 3 bolsillos, la reunión financiera mensual sin peleas, los 7 acuerdos fundamentales y el plan de abundancia compartida para los próximos 5 años.',
    color: 'from-purple-500/20 to-purple-900/20',
    border: 'border-purple-500/30'
  }, {
    emoji: '🛡️',
    title: 'Tomo 4 — El Escudo de la Confianza',
    subtitle: 'Celos y reconstrucción de confianza',
    desc: 'Los 4 tipos de celos, el protocolo de auto-regulación instantánea, el sistema de seguridad emocional y el protocolo de reparación después de una traición.',
    color: 'from-blue-500/20 to-blue-900/20',
    border: 'border-blue-500/30'
  }, {
    emoji: '👶',
    title: 'Tomo 5 — Crianza en Equipo',
    subtitle: 'Ser papá y mamá sin dejar de ser pareja',
    desc: 'El frente unido, la división justa de la carga, la reunión semanal de crianza y el blindaje del "nosotros" para que los hijos unan en vez de separar.',
    color: 'from-orange-500/20 to-orange-900/20',
    border: 'border-orange-500/30'
  }, {
    emoji: '🗺️',
    title: 'Tomo 6 — El Mapa del Futuro',
    subtitle: 'Construyendo un proyecto de vida compartido',
    desc: 'Los valores compartidos, la visión de vida en pareja, el mapa de los 5 años, los rituales de por vida y el manifiesto de pareja que los guiará para siempre.',
    color: 'from-yellow-500/20 to-yellow-900/20',
    border: 'border-yellow-500/30'
  }];
  const includes = ['Teoría clara adaptada a la vida real de pareja', 'Ejercicios prácticos paso a paso', 'Guiones y frases exactas para las situaciones más difíciles', 'Protocolos de intervención para momentos de crisis', 'Plantillas y formatos listos para completar', 'Casos y ejemplos del día a día latinoamericano', '100% lenguaje cercano, sin tecnicismos innecesarios', 'Acuerdos para firmar y sostener en el tiempo'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-800 cv-auto" data-id="element-286">
      <div className="max-w-7xl mx-auto" data-id="element-287">
        {/* Section Header */}
        <ScrollReveal direction="up" className="text-center mb-16" data-id="element-288">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/20 text-gold-400 mb-6 text-3xl" data-id="element-289">
            🏆
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-290">
            MEGAPACK MATRIMONIO SIN CRISIS
          </h2>
          <p className="text-xl text-blue-300 font-medium mb-2" data-id="element-291">
            6 Tomos + 6 Bonos — Para Cualquier Etapa de la Relación
          </p>
          <p className="text-lg text-slate-400" data-id="element-292">
            360+ páginas — Todo resuelto.
          </p>
        </ScrollReveal>

        <div className="text-center mb-12" data-id="element-293">
          <h3 className="text-2xl font-bold text-white" data-id="element-294">
            📚 6 TOMOS COMPLETOS
          </h3>
        </div>

        {/* Tomo Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-295">
          {tomos.map((tomo, index) => <ScrollReveal key={index} direction="up" delay={index + 1} className={`bg-gradient-to-b ${tomo.color} border ${tomo.border} rounded-2xl p-6 backdrop-blur-sm hover:scale-[1.02] transition-transform duration-300`} data-id="element-296">
              <div className="text-4xl mb-4" data-id="element-297">{tomo.emoji}</div>
              <h4 className="text-xl font-bold text-white mb-1" data-id="element-298">
                {tomo.title}
              </h4>
              <p className="text-sm font-semibold text-slate-300 mb-4 pb-4 border-b border-white/10" data-id="element-299">
                {tomo.subtitle}
              </p>
              <p className="text-slate-300 text-sm leading-relaxed" data-id="element-300">
                {tomo.desc}
              </p>
            </ScrollReveal>)}
        </div>

        {/* Cada tomo incluye */}
        <ScrollReveal direction="up" className="bg-navy-900 border border-navy-700 rounded-2xl p-6 md:p-12 max-w-4xl mx-auto" data-id="element-301">
          <h4 className="text-2xl font-bold text-center mb-8" data-id="element-302">
            Cada tomo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-303">
            {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-304">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-305" />
                <span className="text-slate-300" data-id="element-306">{item}</span>
              </div>)}
          </div>
        </ScrollReveal>
      </div>
    </section>;
}